export default __webpack_public_path__ + "static/media/Bengali_book_f.0869b0ad.wav";